export default "__VITE_ASSET__CNhozo3C__"